<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation class="dark bg-gray-900 print:hidden" [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'" [navigation]="navigation.default" [opened]="!isScreenSmall">
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
        <!-- Logo -->
        <div class="flex items-center h-4 p-5 pb-0">
            <!-- Light version -->
            <!-- <img class="dark:hidden w-full" src="assets/icons/footer-logo.svg" alt="Logo image" /> -->
            <!-- Dark version -->
            <!-- <img class="hidden dark:flex w-full" src="assets/icons/footer-logo.svg" alt="Logo image" /> -->
        </div>
    </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">
    <fuse-alert [appearance]="'outline'" [dismissible]="true" [dismissed]="true" [name]="'alert_success'"
        [type]="'success'" *ngIf="alertMessage">
        <span fuseAlertTitle>Success</span>
        {{ alertMessage }}
    </fuse-alert>

    <fuse-alert [appearance]="'outline'" [dismissible]="true" [dismissed]="true" [name]="'alert_error'"
        [type]="'error'">
        <span fuseAlertTitle>Error</span>
        {{ alertMessage }}
    </fuse-alert>
    <!-- Header -->
    <div
        class="relative flex flex-0 items-center w-full h-8 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
        <!-- Navigation toggle button -->
        <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
            <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
        </button>
        <!-- Components -->
        <div class="flex items-center pl-2 space-x-0.5 sm:space-x-2">
            <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
            <user></user>
        </div>
    </div>

    <!-- Content -->
    <div class="flex flex-col flex-auto">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        <router-outlet *ngIf="true"></router-outlet>
    </div>

    <!-- Footer -->
    <!-- <div
        class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
        <span class="font-medium text-secondary">{{ currentYear }} &copy; Myboeken.nl. All rights
            reserved.</span>
    </div> -->
</div>